import React, { useState } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import "./Letting.scss";
import moment from "moment/src/moment";
import { useStaticQuery, graphql } from "gatsby";
import ReactMarkdown from "react-markdown"
import {
    CONTACT_FORM_PAGE_URL,
    CONTACT_PAGE_URL
} from "@Components/common/site/constants";
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";

import { inViewOptions } from '../../../Components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const titleVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 0.4,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const contentVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 1,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const FilterGallery = (props) => {
 
    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => {
                return (
                    <motion.section
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={containerVariants}
                    >
                        <React.Fragment>
                            <section className="letting-section">
                                <Container>
                                    <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                        <Row>
                                            <Col lg={12}>
                                                <div className="content-how-can-we-help">
                                                    <motion.div variants={titleVariants}>
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <h2>{props.Title}<span className="stroke-text">{props.Sub_Title}</span></h2>
                                                        </ScrollAnimation>
                                                    </motion.div>

                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                        <ReactMarkdown source={props.Content} allowDangerousHtml />
                                                    </ScrollAnimation>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            {props.Grid_Block.map(list => {
                                                let processedImages = JSON.stringify({});
                                                if (list?.imagetransforms?.Image_Transforms) {
                                                    processedImages = list.imagetransforms.Image_Transforms;
                                                }
                                                return (
                                                    <Col lg={6} className="grid-list">
                                                        <motion.div variants={contentVariants}>
                                                            <div class="office-bk">
                                                                <picture>
                                                                    <source media="(min-width:992px)" srcSet={list.Image?.url} />
                                                                    <source media="(min-width:768px)" srcSet={list.Image?.url} />
                                                                    <img src={list.Image?.url} alt="" />
                                                                </picture>
                                                                {/* <ImageTransform imagesources={list.Image?.url} renderer="srcSet" imagename='offices.Office_Image.listimg'
                                                                        attr={{ alt: list.Image?.alternativeText, className: '' }}
                                                                        imagetransformresult={processedImages} id={list.id} >
                                                                    </ImageTransform> */}
                                                            </div>
                                                            <div className="person-detail">

                                                                <ScrollAnimation animateOnce={true} animateIn='fadeIn'><h4>{list.Title}</h4></ScrollAnimation>
                                                                <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                                    <ReactMarkdown source={list.Content} allowDangerousHtml />
                                                                </ScrollAnimation>

                                                                <Link className="btn btn-primary d-md-inline-flex" to={list.Cta_Url.Alias}>View Properties</Link>
                                                            </div>
                                                        </motion.div>
                                                    </Col>
                                                )
                                            })
                                            }
                                        </Row>
                                    </ScrollAnimation>
                                </Container>
                            </section>
                        </React.Fragment>
                    </motion.section>
                )
            }}
        </InView>
    )
}

export default FilterGallery;